import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HeartOff } from "lucide-react";
import api from "../api";
import { useFavourites } from "../context/FavouritesContext";
import { useLang } from "../context/LanguageContext";
import DealCard from "../components/dashboard/DealCard";

const Favourites = () => {
  const { favs, pruneFavs } = useFavourites();
  const { t } = useLang();
  const [deals, setDeals] = useState([]);

  useEffect(() => {
    api.get("/deals").then((r) => {
      setDeals(r.data);
      // Drop saves whose deal is gone, so the heart badge matches what's on this page.
      if (r.data.length < 500) pruneFavs(r.data.map((d) => d.id));
    }).catch(() => {});
  }, []);   // eslint-disable-line react-hooks/exhaustive-deps

  const list = deals.filter((d) => favs.includes(d.id));

  return (
    <div className="space-y-6 lp-fade-up">
      <div>
        <h1 className="text-2xl font-extrabold text-foreground">{t("fav.title")}</h1>
        <p className="text-sm text-muted-foreground">{t("fav.subtitle")}</p>
      </div>

      {list.length > 0 ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-5">
          {list.map((d) => (<DealCard key={d.id} deal={d} />))}
        </div>
      ) : (
        <div className="bg-card border border-border rounded-2xl p-12 text-center">
          <span className="h-16 w-16 rounded-full bg-secondary mx-auto flex items-center justify-center mb-4"><HeartOff size={28} className="text-muted-foreground" /></span>
          <h3 className="font-bold text-foreground mb-1">{t("fav.emptyTitle")}</h3>
          <p className="text-sm text-muted-foreground mb-5">{t("fav.emptyMsg")}</p>
          <Link to="/browse" className="inline-block bg-[#16a34a] hover:bg-[#15803d] text-white font-semibold px-6 py-2.5 rounded-xl transition-colors">{t("fav.browse")}</Link>
        </div>
      )}
    </div>
  );
};

export default Favourites;
